
const typography = {
  fontFamily: ['Satoshi','Figtree', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  fontWeightSemibold: 600,
  h1: {
    fontSize: '42px',
    fontWeight: 700,
    lineHeight: '48px',
  },
  h2: {
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: '40px',
  },
  h3: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '32px',
  },
  h4: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '32px',
  },
  h5: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '21px',
  },
  h6: {
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '21px',
  },
  body1: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
  },
  'body-large': {
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '24px',
  },
  'body-small': {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '22px',
  },
  'body-xsmall': {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '18px',
  },



};

export default typography;
